import React from "react";
import StaticPageDetails from "../static_pages_admin/StaticPageDetails";
import Anonymous from "../Anonymous";

function TermsAndConditions() {
  return (
    <Anonymous>
      <StaticPageDetails slug="terms-and-conditions"></StaticPageDetails>
    </Anonymous>
  );
}

export default TermsAndConditions;
